<template>
  <section class="cls">
    <header class="cls__head">
      <div class="cls__brand">
        <img
          :src="require('@/assets/clearmentai/plus.png')"
          alt="Clearment Plus"
          class="cls__plus"
        />
        <div class="cls__brand-text">
          <div class="cls__name">Clearment</div>
          <div class="cls__eyebrow">Sicherheitsklasse</div>
        </div>
      </div>
      <button
        type="button"
        class="cls__info"
        @click="berechnungStore.setShowPop(tarif, 'clearmentlsk')"
      >
        <v-icon icon="mdi-information-outline" size="14" />
        Info
      </button>
    </header>

    <div class="cls__body">
      <p class="cls__text">
        Die <strong>{{ tarif.un_name }} {{ tarif.tarif_title }}</strong> hat
        <span v-if="tarif.tarif_clearment_lsk == 5">
          die <b class="cls__pos">höchstmögliche</b> Clearment
          Leistungs-Sicherheitsklasse.
        </span>
        <span v-if="tarif.tarif_clearment_lsk == 3">
          die <b class="cls__mid">zweithöchste</b> Clearment
          Leistungs-Sicherheitsklasse.
        </span>
        <span v-if="tarif.tarif_clearment_lsk == 1">
          die Clearment Leistungs-Sicherheitsklasse <b>1</b>.
        </span>
      </p>

      <ul class="cls__ladder">
        <li
          class="cls__step cls__step--5"
          :class="{ 'is-active': tarif.tarif_clearment_lsk == 5 }"
        >
          <span class="cls__num">LSK&nbsp;5</span>
          <span class="cls__lab">höchste Sicherheit</span>
        </li>
        <li
          class="cls__step cls__step--3"
          :class="{ 'is-active': tarif.tarif_clearment_lsk == 3 }"
        >
          <span class="cls__num">LSK&nbsp;3</span>
          <span class="cls__lab">zweithöchste</span>
        </li>
        <li
          class="cls__step cls__step--1"
          :class="{ 'is-active': tarif.tarif_clearment_lsk == 1 }"
        >
          <span class="cls__num">LSK&nbsp;1</span>
          <span class="cls__lab">Basis</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup>
  import { defineProps } from "vue";
  import { useBerechnungStore } from "@/stores/berechnung";
  const berechnungStore = useBerechnungStore();

  defineProps({
    tarif: { type: Object, default: () => ({}) },
    berechnung: { type: Object, default: () => ({}) },
  });
</script>

<style scoped>
  .cls {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-radius: 3px;
    overflow: hidden;
  }
  .cls__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 9px 12px;
    border-bottom: 1px solid #eef1f6;
    background: #fafbfc;
  }
  .cls__brand {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
  }
  .cls__plus {
    width: 28px;
    height: auto;
    display: block;
    flex-shrink: 0;
  }
  .cls__brand-text {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    min-width: 0;
  }
  .cls__name {
    font-size: 13px;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.1px;
  }
  .cls__eyebrow {
    display: inline-flex;
    align-items: center;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1px;
    color: #5b6473;
    text-transform: uppercase;
  }
  .cls__info {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: transparent;
    border: 1px solid #c8d0db;
    border-radius: 3px;
    padding: 2px 8px;
    font-size: 11.5px;
    font-weight: 600;
    color: #0f4c81;
    cursor: pointer;
  }
  .cls__info:hover {
    background: #f0f5fa;
    border-color: #0f4c81;
  }

  .cls__body {
    padding: 10px 12px 12px;
  }
  .cls__text {
    margin: 0 0 10px;
    font-size: 13px;
    line-height: 1.5;
    color: #1f2937;
  }
  .cls__pos {
    color: #2e7d32;
  }
  .cls__mid {
    color: #b85a00;
  }

  .cls__ladder {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .cls__step {
    display: grid;
    grid-template-columns: 60px 1fr;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background: #fafbfc;
    border: 1px solid #eef1f6;
    border-left: 3px solid #d8dde5;
    border-radius: 3px;
    color: #9ca3af;
  }
  .cls__num {
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.4px;
  }
  .cls__lab {
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  .cls__step.is-active.cls__step--5 {
    background: #e7f3ea;
    border-color: #c5e1cb;
    border-left-color: #2e7d32;
    color: #2e7d32;
  }
  .cls__step.is-active.cls__step--3 {
    background: #fff3e0;
    border-color: #ffd9a8;
    border-left-color: #f6a800;
    color: #b85a00;
  }
  .cls__step.is-active.cls__step--1 {
    background: #f0f5fa;
    border-color: #d8e3ee;
    border-left-color: #0f4c81;
    color: #0f4c81;
  }
</style>
